
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[centre]/offer/[id]/[slug]",
      function () {
        return require("private-next-pages/[centre]/offer/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[centre]/offer/[id]/[slug]"])
      });
    }
  